import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
  ResponsiveContainer, PieChart, Pie, Cell, Legend, Label, Text,
} from 'recharts';

class NWDonutChart extends PureComponent {
  render() {
    const {
      data, containerWidth, containerHeight, innerRadius, outerRadius,
      cx, cy, paddingAngle, dataKey, isLegend, customLegend,
      pieName, legendAlign, legendVerticalAlign, labelFill, legendWidth,
      legendStyle, showPercentage,
    } = this.props;

    const renderCustomizedLabel = props => (
      <Text
        {...props}
        fill="#757679"
        alignmentBaseline="middle"
        className="recharts-pie-label-text"
      >
        {`${props.value}%`}
      </Text>
    );

    return (
      <ResponsiveContainer width={containerWidth} height={containerHeight}>
        <PieChart
          margin={{
            top: 1, left: 1, right: 1, bottom: 1,
          }}
        >
          <Pie
            blendStroke
            data={data}
            cx={cx}
            cy={cy}
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            paddingAngle={paddingAngle}
            dataKey={dataKey}
            startAngle={-270}
            label={showPercentage ? renderCustomizedLabel : null}
            labelLine={false}
          >
            {
                data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} />)
              }
            <Label width={30} value={pieName} position="center" fill={labelFill} />
          </Pie>
          {isLegend && (
          <Legend
            content={customLegend}
            layout="vertical"
            verticalAlign={legendVerticalAlign}
            align={legendAlign}
            wrapperStyle={legendStyle}
            iconType="circle"
            iconSize={8}
            width={legendWidth}
          />
          )}
        </PieChart>
      </ResponsiveContainer>
    );
  }
}

NWDonutChart.propTypes = {
  // The source data which each element is an object.
  data: PropTypes.arrayOf(PropTypes.object),
  // The width of chart container.
  containerWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // The height of chart container.
  containerHeight: PropTypes.string,
  // The inner radius of all the sectors.
  innerRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // The outer radius of all the sectors.
  outerRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // The x-coordinate of center. If set a percentage.
  cx: PropTypes.string,
  // The y-coordinate of center. If set a percentage.
  cy: PropTypes.string,
  // The angle between two sectors.
  paddingAngle: PropTypes.number,
  // The key of each sector's value.
  dataKey: PropTypes.string,
  // display legend or not
  isLegend: PropTypes.bool,
  legendAlign: PropTypes.string,
  legendVerticalAlign: PropTypes.string,
  labelFill: PropTypes.string,
  customLegend: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  legendWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // eslint-disable-next-line react/forbid-prop-types
  legendStyle: PropTypes.object,
  showPercentage: PropTypes.bool,
};

NWDonutChart.defaultProps = {
  data: [
    { name: 'Group A', value: 400, color: '#0088FE' },
    { name: 'Group B', value: 300, color: '#00C49F' },
    { name: 'Group C', value: 300, color: '#FFBB28' },
    { name: 'Group D', value: 200, color: '#FF8042' },
  ],
  containerWidth: '100%',
  containerHeight: '100%',
  innerRadius: '80%',
  outerRadius: '100%',
  cx: '50%',
  cy: '50%',
  paddingAngle: 0,
  dataKey: 'value',
  isLegend: false,
  legendAlign: 'right',
  legendVerticalAlign: 'middle',
  labelFill: '#fff',
  customLegend: null,
  legendWidth: null,
  legendStyle: {
    transform: 'translateX(10px)',
  },
  showPercentage: false,
};

export default NWDonutChart;
